exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".powershell-page .installed-agent-selector{padding:10px}.powershell-page .installed-agent-selector .icon-holder{margin-right:5px;float:left}.powershell-page .installed-agent-selector .icon-holder img{width:36px;height:36px;margin-right:5px}.powershell-page .installed-agent-selector .download-link-holder a{font-weight:700}.powershell-page .installed-agent-selector .download-link-holder p{font-size:85%;line-height:10px}.powershell-page .powershell-example{background-color:#f2f2f2;padding:5px;margin-bottom:30px;margin-left:10px;font-size:85%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/settings/PowerShellPage/powershellpage.scss
// module id = 1035
// module chunks = 0